import { Maybe } from '../utils/types';

declare global {
	interface Window {
		spy: (tag: string) => <FirstArg>(first: FirstArg, ...rest: unknown[]) => FirstArg;
		skippay: {
			readonly environment: string;
			readonly name: string;
			readonly version: string;
		};
	}
}

if (process.env.NODE_ENV === 'development') {
	window.spy =
		(tag) =>
		(...input) => {
			// eslint-disable-next-line no-console
			console.log(tag, ...input);
			return input[0];
		};
}

window.skippay = window.skippay || {};

interface PropsInit {
	environment: 'development' | 'accept' | 'integration' | 'prod';
	name: Maybe<string>;
	version: Maybe<string>;
}

export const init = ({ environment = 'development', name, version }: PropsInit): void => {
	Object.defineProperties(window.skippay, {
		environment: {
			enumerable: true,
			value: environment,
		},
		name: {
			enumerable: true,
			value: name,
		},
		version: {
			enumerable: true,
			value: version,
		},
	});
};
